import { Navigate, Route, Routes } from "react-router-dom";
import { PageTitle } from "../../../_start/layout/core";
import { SeoSettingsPage } from "./pages/SeoSettingsPage";

export const SettingsPage = () => {
	return (
		<Routes>
			{/* begin::SEO ROUTES */}
			<Route
				path="seo"
				element={
					<>
						<PageTitle>SEO</PageTitle>
						<SeoSettingsPage />
					</>
				}
			/>
			{/* end::SEO ROUTES */}

			<Route index element={<Navigate to="/settings/seo" replace />} />
			<Route path="*" element={<Navigate to="/settings/seo" replace />} />
		</Routes>
	);
};
